import { FormFieldComponent, FieldConfig } from './form-field.model';
import { FormGroup } from '@angular/forms';
import { FormConfigInstance } from '../services/form.service';
import { CleanSubscriptions } from 'src/app/core/classes/clean-subcriptions';
import { OnInit, ChangeDetectorRef, OnDestroy, Component, HostBinding, ViewRef } from '@angular/core';
import { FormFieldService } from '../services/form-field.service';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  template: '',
  host: {
    '[style]': 'field.hostStyle'
  }
})
export class FormBaseComponent<T extends FieldConfig = FieldConfig> extends CleanSubscriptions
  implements FormFieldComponent<FormConfigInstance, T>, OnInit, OnDestroy {

  field: T;
  group: FormGroup;
  service: FormConfigInstance;

  classNames = '';

  state: 'edit' | 'idle';

  onComponentInit() { };
  onComponentDestroy() { };

  constructor(
    private _cd: ChangeDetectorRef,
    public _service: FormFieldService,
    private _sanitizer: DomSanitizer
  ) {
    super();
  }

  getHostStyles(): SafeStyle {
    let styles = '';
    if (this.field?.hostStyle) {
      Object.keys(this.field.hostStyle).forEach(key => {
        const value = this.field.hostStyle[key];
        styles = key + ':' + value + ';'
      });
    }
    return this._sanitizer.bypassSecurityTrustStyle(styles);
  }

  ngOnInit() {
    this.setRootClasses();

    this._service.addControl(this.group, this.field);
    const control = this.group.get(this.field.name);

    if (this.service.isEnabledFn) {
      this.isEnabledFn = this.service.isEnabledFn;
    }

    setTimeout(() => {
      if (this && this._cd && !(this._cd as ViewRef).destroyed) {
        this._cd.detectChanges();
      }
    }, 100)

    if (control) {

      // set default value
      if (control.value == null && this.field.defaultValue) {
        control.setValue(this.field.defaultValue);
      }
      // value changes proxy
      this.subscribe = control.valueChanges.subscribe(value => {
        if (!value && this.field.defaultValue) {
          control.setValue(this.field.defaultValue);
          value = this.field.defaultValue;
        }

        this.service.fieldChanged.next({
          fieldName: this.field.name,
          fieldId: this.field.id,
          value
        });

        if (this.field.valueChanges) {
          const callCd = this.field.valueChanges(this.field, value, this.service);

          if (callCd) {
            this.service.detectChanges$.next();
          }
        }
      });

    }

    this.subscribe = this.service.form.valueChanges.subscribe(value => {
      const changed = this.updateVisibility();
      if (changed) {
        this.service.detectChanges$.next();
      }
    });

    this.subscribe = this.service.state.subscribe(state => {
      this.state = state;
      setTimeout(() => {
        if (this._cd && !(this._cd as ViewRef).destroyed) {
          this._cd.detectChanges();
        }
      }, 1);
    });

    this.updateVisibility();
    this.onComponentInit();

  }

  ngOnDestroy() {
    // remove control from form
    this._service.removeControl(this.group, this.field);
    this.onComponentDestroy();
  }

  private updateFormControl() {
    if (this.field._isVisible) {
      this._service.addControl(this.group, this.field);
    } else {
      this._service.removeControl(this.group, this.field);
    }
  }

  isEnabledFn(fieldName: string, fieldId: any) {
    if (this.field.readonly === true) {
      return false;
    }
    return this.state === 'edit';
  }

  updateVisibility(): boolean {

    if (typeof this.field.visible === 'boolean') {
      this.field._isVisible = this.field.visible;
      this.updateFormControl();
      this.setRootClasses();
      return true;
    }

    if (typeof this.field.visible === 'function') {

      const _lastVisibility = this.field._isVisible;
      const values = this.service.form.value;
      let value;
      if (this.field.name && Object.hasKey(values, this.field.name)) {
        value = values[this.field.name];
      }

      this.field._isVisible = this.field.visible(values, value, this.service);

      this.setRootClasses();
      this.updateFormControl();
      return _lastVisibility !== this.field._isVisible;
    }

    this.field._isVisible = true;

    this.setRootClasses();
    this.updateFormControl();
    return true;
  }

  setRootClasses() {
    const classes = ['field-' + this.field.type];

    if (this.field.classes && this.field.classes.length > 0) {
      classes.push(...this.field.classes);
    }

    if (!this.field._isVisible) {
      classes.push('hidden');
    }

    this.classNames = classes.join(' ');
  }

}
